"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var router_1 = require("@angular/router");
var base_portfolio_component_1 = require("./base-portfolio.component");
var basePortfolioConfig = [
    {
        path: ':mainCategoryName',
        component: base_portfolio_component_1.BasePortfolioComponent,
    },
    {
        path: ':mainCategoryName/:cid/:categoryName',
        component: base_portfolio_component_1.BasePortfolioComponent
    },
    {
        path: ':mainCategoryName/:cid/custom/documents-manager',
        loadChildren: function() { return new Promise(function (resolve, reject) {  require.ensure([], function (require) {    resolve(require('../root-category-documents/root-category-documents.module')['RootCategoryDocumentsModule']);  }, function(e) {    reject({ loadChunkError: true, details: e });  });}) }
    },
];
exports.basePortfolioRouting = router_1.RouterModule.forChild(basePortfolioConfig);
//# sourceMappingURL=base-portfolio.routing.js.map